import axios from "axios"
import { API_ROOT_URL } from "../requests"

export const MEDICATIONS = "medications"
export const FILTERED_MEDICATIONS = "filteredMedications"

export const fetchMedications = async ()  => {
  const url = `${API_ROOT_URL}/medications/`
  const { data: medications } = await axios.get(url)
  return { type: MEDICATIONS, payload: medications }
}

export const addMedication = (medication) => async (dispatch, getState) => {
  let { medications } = getState()
  const url = `${API_ROOT_URL}/medications/`
  const { data: newMedication } = await axios.post(url, medication)
  const updatedMedications = [...medications, newMedication]
  dispatch({ type: MEDICATIONS, payload: updatedMedications })
}

export const removeMedication = (medicationId) => async (dispatch, getState) => {
  let { medications } = getState()
  const url = `${API_ROOT_URL}/medications/${medicationId}/`
  await axios.delete(url)
  medications = medications.filter( m => m.id !== medicationId)
  dispatch({ type: MEDICATIONS, payload: medications })
}

export const filterMedications = (filteredMedications) =>  {
  return ({ type: FILTERED_MEDICATIONS, payload: filteredMedications })
}

export const updateMedication = (medicationId, data) => async (dispatch, getState) => {
  const { medications } = getState()
  const url = `${API_ROOT_URL}/medications/${medicationId}/`
  await axios.put(url, data)
  const medicationsWithoutCurrentMedication = medications.filter( m => m.id !== medicationId)
  let updatedMedication = medications.find( m => m.id === medicationId)
  updateMedication.excludeType = data.excludeType
  dispatch({ type: MEDICATIONS, payload: [...medicationsWithoutCurrentMedication, updatedMedication] })
}